export default {
    'loginForm.title': 'Вход',
    'loginForm.fields.email.label': 'Электронная почта',
    'loginForm.fields.password.label': 'Пароль',
    'loginForm.buttons.login.title': 'Вход',
    'loginForm.errors.unableLogin': 'Ошибка входа. Пожалуйста, попробуйте позднее.',
    'loginForm.fields.forgotPassword.label': 'Забыли пароль?',

    'accountRecoveryInitiate.title': 'Забыли пароль?',
    'accountRecoveryInitiate.buttons.restore.title': 'Восстановить',
    'accountRecoveryInitiate.buttons.back.title': 'Назад',
    'accountRecoveryInitiate.fields.email.label': 'Электронная почта',
    'accountRecoveryInitiate.errors.unableRecovery': 'Ошибка восстановления аккаунта. Пожалуйста, попробуйте позднее.',
    'accountRecoveryInitiate.events.emailSentSuccess': 'Письмо с инструкциями по восстановлению аккаунта успешно отправлено',
    'accountRecoveryInitiate.hint.nextAttemptAfter': 'Следующая попытка возможна через',
    'accountRecoveryInitiate.description': 'Отправим ссылку для входа на почту',

    'accountRecoveryFinish.title': 'Установка пароля',
    'accountRecoveryFinish.errors.unableRecovery': 'Ошибка восстановления аккаунта. Пожалуйста, попробуйте позднее.',
    'accountRecoveryFinish.hint.enterPasswordForAccount': 'Укажите новый пароль для вашего аккаунта',
    'accountRecoveryFinish.buttons.tryAgain.title': 'Повторить',
    'accountRecoveryFinish.fields.password.label': 'Пароль',
    'accountRecoveryFinish.fields.password.hint': 'Должен содержать хотя бы одну цифру и быть не короче 8 символов',
    'accountRecoveryFinish.fields.confirmPassword.label': 'Подтверждение пароля',
    'accountRecoveryFinish.buttons.restore.title': 'Восстановить',
    'accountRecoveryFinish.validation.passwordMaxLength': 'Пароль не должен превышать 72 символа',
    'accountRecoveryFinish.validation.passwordMinLength': 'Пароль не должен быть короче 8 символов',
    'accountRecoveryFinish.validation.noPassword': 'Введите пароль',
    'accountRecoveryFinish.validation.noConfirmPassword': 'Введите подтверждение пароля',
    'accountRecoveryFinish.validation.passwordsMismatch': 'Пароли не совпадают',
    'accountRecoveryFinish.notification.accountRecovered': 'Доступ к аккаунту успешно восстановлен! Воспользуйтесь новым паролем для входа в личный кабинет',

    'invite.title': 'Завершение создания аккаунта',
    'invite.fields.password.label': 'Пароль',
    'invite.fields.password.hint': 'Должен содержать хотя бы одну цифру и быть не короче 8 символов',
    'invite.fields.confirmPassword.label': 'Подтверждение пароля',
    'invite.errors.unableRecovery': 'Ошибка завершения регистрации аккаунта. Пожалуйста, попробуйте позднее.',
    'invite.validation.passwordMaxLength': 'Пароль не должен превышать 72 символа',
    'invite.validation.passwordMinLength': 'Пароль не должен быть короче 8 символов',
    'invite.validation.noPassword': 'Введите пароль',
    'invite.validation.noConfirmPassword': 'Введите подтверждение пароля',
    'invite.validation.passwordsMismatch': 'Пароли не совпадают',
    'invite.hint.enterPasswordForAccount': 'Пожалуйста, задайте пароль для аккаунта',
    'invite.buttons.confirm.title': 'Подтвердить',
    'invite.notification.accountConfirmed': 'Вы успешно завершили регистрацию аккаунта! Воспользуйтесь заданным паролем для входа в личный кабинет',

    'common.close': 'Закрыть',

    'fg.components.footer.contactEmailDescription': 'По всем вопросам пишите на почту',
    'kromos.components.footer.contactEmailDescription': 'По всем вопросам пишите на почту',
    'fg.components.footer.contactEmail': 'lab@f-genetics.com',
    'kromos.components.footer.contactEmail': 'lab@kromos.ge',
    'fg.components.footer.yearSince': '2020',
    'kromos.components.footer.yearSince': '2022',
    'fg.components.footer.company': 'f-genetics.com',
    'kromos.components.footer.company': 'kromos.ge',
}